var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",attrs:{"id":"main"}},[_c('sdk-index'),_c('iframe',{ref:"iframe",attrs:{"src":_vm.src,"id":"iframe","scrolling":"auto","frameborder":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }